import {
  Button,
  HeadingText,
  ImageMessage,
  Modal,
  ParagraphText,
  StackLayout,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import accountDeletedIcon from 'assets/account-deleted-icon.svg';
import { BaseModalContainer } from 'components/modals/common/base-modal.component';

export const AccountDeletionConfirmationModal = () => {
  const { formatMessage } = useIntl();

  return (
    <BaseModalContainer
      footer={
        <StackLayout
          horizontalAlignment={{ '@initial': 'end', '@mobile': 'center' }}
          orientation={{ '@initial': 'horizontal', '@mobile': 'vertical' }}
          spacing="$one"
          css={{ flexGrow: 0 }}
        >
          <Modal.Close asChild>
            <Button
              priority="primary"
              size="large"
              css={{
                width: 229,
                '@mobile': { width: '100%' },
                backgroundColor: '$primaryBackgroundDefault',
                '&:hover': { backgroundColor: '$primaryBackgroundHovered' },
                justifyContent: 'center',
              }}
            >
              {formatMessage({ id: 'STR_I_UNDERSTAND' })}
            </Button>
          </Modal.Close>
        </StackLayout>
      }
    >
      <ImageMessage
        image={accountDeletedIcon}
        imageGap={{ '@initial': '$oneAndHalf', '@mobile': '$one' }}
        css={{
          padding: '$oneAndHalf $none $three',
          textAlign: 'left',
          '@mobile': { padding: '$oneAndHalf $none $twoAndHalf' },
        }}
      >
        <Modal.Title asChild>
          <HeadingText
            level="2"
            size="lg"
            css={{ paddingBlock: '$half', textAlign: 'left' }}
          >
            {formatMessage({ id: 'STR_ACCOUNT_DELETED_HEADING' })}
          </HeadingText>
        </Modal.Title>
        <ParagraphText css={{ marginBlockEnd: '$half !important' }}>
          {formatMessage({ id: 'STR_ACCOUNT_DELETED_BODY_1' })}
        </ParagraphText>
        <ParagraphText>
          {formatMessage({ id: 'STR_ACCOUNT_DELETED_BODY_2' })}
        </ParagraphText>
      </ImageMessage>
    </BaseModalContainer>
  );
};
